import React from 'react'
import orderBy from 'lodash/orderBy'
import './PrintTable.scss'

const PrintTable = ({ template, rows }) => {
  React.useEffect(() => {
    window.print()
  }, [])

  const sortedRows = orderBy(Object.entries(rows).map(([key, value]) => ({ ...value, id: key })), ['SORT_INDEX'])

  return (
    <div className='print-table'>
      <table>
        <thead>
          <tr>
            {template.map(t => (
              <th key={t.id}>{t.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedRows.map(row => (
            <tr key={row.id}>
              {template.map(t => (
                <td key={t.id}>{row[t.id]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PrintTable



// WEBPACK FOOTER //
// ./src/components/PrintResults/PrintTable.js